__turbopack_context__.v({
  "bottom-left": "notificationToast-module-scss-module__ojnFta__bottom-left",
  "bottom-right": "notificationToast-module-scss-module__ojnFta__bottom-right",
  "device-update-error-container": "notificationToast-module-scss-module__ojnFta__device-update-error-container",
  "error-container": "notificationToast-module-scss-module__ojnFta__error-container",
  "notification": "notificationToast-module-scss-module__ojnFta__notification",
  "notification-container": "notificationToast-module-scss-module__ojnFta__notification-container",
  "notification-image": "notificationToast-module-scss-module__ojnFta__notification-image",
  "notification-image-error": "notificationToast-module-scss-module__ojnFta__notification-image-error",
  "notification-image-success": "notificationToast-module-scss-module__ojnFta__notification-image-success",
  "notification-message": "notificationToast-module-scss-module__ojnFta__notification-message",
  "notification-title": "notificationToast-module-scss-module__ojnFta__notification-title",
  "toast": "notificationToast-module-scss-module__ojnFta__toast",
  "toast-in-left": "notificationToast-module-scss-module__ojnFta__toast-in-left",
  "toast-in-right": "notificationToast-module-scss-module__ojnFta__toast-in-right",
  "top-left": "notificationToast-module-scss-module__ojnFta__top-left",
  "top-right": "notificationToast-module-scss-module__ojnFta__top-right",
});
